import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import MaterialButton from '@material-ui/core/Button';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { makeStyles } from '@material-ui/core/styles';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useDefaultButtonStyles = makeStyles(function (theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
  return {
    root: Object.assign(Object.assign(_defineProperty({
      padding: "0px 18px",
      height: "32px",
      boxShadow: "none",
      border: "1px solid ".concat(theme.palette.common.black),
      backgroundColor: theme.palette.common.black
    }, theme.breakpoints.down("sm"), {
      height: "41px"
    }), (_a = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _a === void 0 ? void 0 : _a.root), {
      "&:hover": Object.assign(Object.assign({
        opacity: 0.7,
        boxShadow: "none",
        backgroundColor: theme.palette.common.black
      }, (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _b === void 0 ? void 0 : _b.hover) === null || _c === void 0 ? void 0 : _c.root), {
        "& $label": Object.assign({}, (_e = (_d = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _d === void 0 ? void 0 : _d.hover) === null || _e === void 0 ? void 0 : _e.label)
      }),
      "&$disabled": Object.assign(Object.assign({}, (_g = (_f = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _f === void 0 ? void 0 : _f.disabled) === null || _g === void 0 ? void 0 : _g.root), {
        "& $label": Object.assign({}, (_j = (_h = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _h === void 0 ? void 0 : _h.disabled) === null || _j === void 0 ? void 0 : _j.label)
      }),
      "&:focus": Object.assign(Object.assign({
        boxShadow: "0px 0px 3px ".concat(theme.palette.common.black),
        border: "1px solid ".concat(theme.palette.common.black)
      }, (_l = (_k = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _k === void 0 ? void 0 : _k.focus) === null || _l === void 0 ? void 0 : _l.root), {
        "& $label": Object.assign({}, (_o = (_m = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _m === void 0 ? void 0 : _m.focus) === null || _o === void 0 ? void 0 : _o.label)
      })
    }),
    label: Object.assign({
      textTransform: "none",
      fontSize: "14px",
      fontWeight: 600,
      color: theme.palette.common.white
    }, (_p = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _p === void 0 ? void 0 : _p.label),
    disabled: {}
  };
});
var usePrimaryButtonStyles = makeStyles(function (theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
  return {
    root: Object.assign(Object.assign({
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.main
    }, (_b = (_a = theme.buttons) === null || _a === void 0 ? void 0 : _a.primary) === null || _b === void 0 ? void 0 : _b.root), {
      "&:hover": Object.assign(Object.assign({
        backgroundColor: theme.palette.primary.main
      }, (_e = (_d = (_c = theme.buttons) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.hover) === null || _e === void 0 ? void 0 : _e.root), {
        "& $label": Object.assign({}, (_h = (_g = (_f = theme.buttons) === null || _f === void 0 ? void 0 : _f.primary) === null || _g === void 0 ? void 0 : _g.hover) === null || _h === void 0 ? void 0 : _h.label)
      }),
      "&$disabled": Object.assign(Object.assign({}, (_l = (_k = (_j = theme.buttons) === null || _j === void 0 ? void 0 : _j.primary) === null || _k === void 0 ? void 0 : _k.disabled) === null || _l === void 0 ? void 0 : _l.root), {
        "& $label": Object.assign({}, (_p = (_o = (_m = theme.buttons) === null || _m === void 0 ? void 0 : _m.primary) === null || _o === void 0 ? void 0 : _o.disabled) === null || _p === void 0 ? void 0 : _p.label)
      }),
      "&:focus": Object.assign(Object.assign({
        border: "1px solid ".concat(theme.palette.primary.main),
        boxShadow: "0px 0px 3px ".concat(theme.palette.primary.main)
      }, (_s = (_r = (_q = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _q === void 0 ? void 0 : _q.primary) === null || _r === void 0 ? void 0 : _r.focus) === null || _s === void 0 ? void 0 : _s.root), {
        "& $label": Object.assign({}, (_v = (_u = (_t = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _t === void 0 ? void 0 : _t.primary) === null || _u === void 0 ? void 0 : _u.focus) === null || _v === void 0 ? void 0 : _v.label)
      })
    }),
    label: Object.assign({
      color: theme.palette.common.white
    }, (_x = (_w = theme.buttons) === null || _w === void 0 ? void 0 : _w.primary) === null || _x === void 0 ? void 0 : _x.label),
    disabled: {}
  };
});
var useSecondaryButtonStyles = makeStyles(function (theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
  return {
    root: Object.assign(Object.assign({
      borderColor: theme.palette.primary.main,
      backgroundColor: "transparent"
    }, (_b = (_a = theme.buttons) === null || _a === void 0 ? void 0 : _a.secondary) === null || _b === void 0 ? void 0 : _b.root), {
      "&:hover": Object.assign(Object.assign({
        backgroundColor: "transparent"
      }, (_e = (_d = (_c = theme.buttons) === null || _c === void 0 ? void 0 : _c.secondary) === null || _d === void 0 ? void 0 : _d.hover) === null || _e === void 0 ? void 0 : _e.root), {
        "& $label": Object.assign({}, (_h = (_g = (_f = theme.buttons) === null || _f === void 0 ? void 0 : _f.secondary) === null || _g === void 0 ? void 0 : _g.hover) === null || _h === void 0 ? void 0 : _h.label)
      }),
      "&$disabled": Object.assign(Object.assign({}, (_l = (_k = (_j = theme.buttons) === null || _j === void 0 ? void 0 : _j.secondary) === null || _k === void 0 ? void 0 : _k.disabled) === null || _l === void 0 ? void 0 : _l.root), {
        "& $label": Object.assign({}, (_p = (_o = (_m = theme.buttons) === null || _m === void 0 ? void 0 : _m.secondary) === null || _o === void 0 ? void 0 : _o.disabled) === null || _p === void 0 ? void 0 : _p.label)
      }),
      "&:focus": Object.assign(Object.assign({
        border: "1px solid ".concat(theme.palette.primary.main),
        boxShadow: "0px 0px 3px ".concat(theme.palette.primary.main)
      }, (_s = (_r = (_q = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _q === void 0 ? void 0 : _q.secondary) === null || _r === void 0 ? void 0 : _r.focus) === null || _s === void 0 ? void 0 : _s.root), {
        "& $label": Object.assign({}, (_v = (_u = (_t = theme === null || theme === void 0 ? void 0 : theme.buttons) === null || _t === void 0 ? void 0 : _t.secondary) === null || _u === void 0 ? void 0 : _u.focus) === null || _v === void 0 ? void 0 : _v.label)
      })
    }),
    label: Object.assign({
      color: theme.palette.primary.main
    }, (_x = (_w = theme.buttons) === null || _w === void 0 ? void 0 : _w.secondary) === null || _x === void 0 ? void 0 : _x.label),
    disabled: {}
  };
});

var Button = forwardRef(function (_a, ref) {
  var _b = _a.classes,
    _c = _b === void 0 ? {} : _b,
    _c$root = _c.root,
    root = _c$root === void 0 ? "" : _c$root,
    _c$label = _c.label,
    label = _c$label === void 0 ? "" : _c$label,
    _c$disabled = _c.disabled,
    disabled = _c$disabled === void 0 ? "" : _c$disabled,
    classes = __rest(_c, ["root", "label", "disabled"]),
    buttonProps = __rest(_a, ["classes"]);
  var defaultClasses = useDefaultButtonStyles();
  return React.createElement(MaterialButton, Object.assign({
    variant: "contained",
    ref: ref,
    disableRipple: true,
    classes: Object.assign({
      root: clsx(defaultClasses.root, root),
      label: clsx(defaultClasses.label, label),
      disabled: clsx(defaultClasses.disabled, disabled)
    }, classes)
  }, buttonProps));
});

var PrimaryButton = forwardRef(function (_a, ref) {
  var _a$classes = _a.classes,
    customClasses = _a$classes === void 0 ? {
      root: "",
      label: "",
      disabled: ""
    } : _a$classes,
    buttonProps = __rest(_a, ["classes"]);
  var parsedClasses = usePrimaryButtonStyles();
  var classes = useMemo(function () {
    var root = customClasses.root,
      label = customClasses.label,
      disabled = customClasses.disabled,
      otherClasses = __rest(customClasses, ["root", "label", "disabled"]);
    return Object.assign({
      root: clsx(parsedClasses.root, root),
      label: clsx(parsedClasses.label, label),
      disabled: clsx(parsedClasses.disabled, disabled)
    }, otherClasses);
  }, [customClasses, parsedClasses]);
  // eslint-disable-next-line react/jsx-props-no-spreading
  return React.createElement(Button, Object.assign({}, buttonProps, {
    ref: ref,
    classes: classes
  }));
});

var SecondaryButton = forwardRef(function (_a, ref) {
  var _a$classes = _a.classes,
    customClasses = _a$classes === void 0 ? {
      root: "",
      label: "",
      disabled: ""
    } : _a$classes,
    buttonProps = __rest(_a, ["classes"]);
  var parsedClasses = useSecondaryButtonStyles();
  var classes = useMemo(function () {
    var _a = customClasses || {},
      root = _a.root,
      label = _a.label,
      disabled = _a.disabled,
      otherClasses = __rest(_a, ["root", "label", "disabled"]);
    return Object.assign({
      root: clsx(parsedClasses.root, root),
      label: clsx(parsedClasses.label, label),
      disabled: clsx(parsedClasses.label, disabled)
    }, otherClasses);
  }, [customClasses, parsedClasses]);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Button, Object.assign({
      ref: ref,
      variant: "outlined"
    }, buttonProps, {
      classes: classes
    }))
  );
});

export { Button, PrimaryButton, SecondaryButton };
//# sourceMappingURL=main.esm.js.map
